"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var createModule = function createModule(moduleData) {
  var _moduleData$middlewar, _moduleData$middlewar2, _moduleData$middlewar3, _moduleData$middlewar4, _moduleData$middlewar5, _moduleData$middlewar6;

  return {
    name: moduleData.name,
    extendStore: moduleData === null || moduleData === void 0 ? void 0 : moduleData.extendStore,
    featureKeys: moduleData === null || moduleData === void 0 ? void 0 : moduleData.featureKeys,
    dispatchers: moduleData === null || moduleData === void 0 ? void 0 : moduleData.dispatchers,
    reducerActions: moduleData === null || moduleData === void 0 ? void 0 : moduleData.reducerActions,
    middleware: {
      log: moduleData === null || moduleData === void 0 ? void 0 : (_moduleData$middlewar = moduleData.middleware) === null || _moduleData$middlewar === void 0 ? void 0 : _moduleData$middlewar.log,
      run: moduleData === null || moduleData === void 0 ? void 0 : (_moduleData$middlewar2 = moduleData.middleware) === null || _moduleData$middlewar2 === void 0 ? void 0 : _moduleData$middlewar2.run,
      check: moduleData === null || moduleData === void 0 ? void 0 : (_moduleData$middlewar3 = moduleData.middleware) === null || _moduleData$middlewar3 === void 0 ? void 0 : _moduleData$middlewar3.check,
      process: moduleData === null || moduleData === void 0 ? void 0 : (_moduleData$middlewar4 = moduleData.middleware) === null || _moduleData$middlewar4 === void 0 ? void 0 : _moduleData$middlewar4.process,
      callback: moduleData === null || moduleData === void 0 ? void 0 : (_moduleData$middlewar5 = moduleData.middleware) === null || _moduleData$middlewar5 === void 0 ? void 0 : _moduleData$middlewar5.callback,
      payloadListener: moduleData === null || moduleData === void 0 ? void 0 : (_moduleData$middlewar6 = moduleData.middleware) === null || _moduleData$middlewar6 === void 0 ? void 0 : _moduleData$middlewar6.payloadListener
    },
    renderComponent: moduleData === null || moduleData === void 0 ? void 0 : moduleData.renderComponent,
    namespaceDispatchers: moduleData === null || moduleData === void 0 ? void 0 : moduleData.namespaceDispatchers,
    namespaceFeatureKeys: moduleData === null || moduleData === void 0 ? void 0 : moduleData.namespaceFeatureKeys,
    namespace: moduleData === null || moduleData === void 0 ? void 0 : moduleData.namespace,
    importModules: moduleData === null || moduleData === void 0 ? void 0 : moduleData.importModules
  };
};

var _default = createModule;
exports["default"] = _default;
module.exports = exports.default;